import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Pagination from 'material-ui-flat-pagination';

const styles = theme => ({
  center: {
    width: 'fit-content',
    margin: '0 auto',
  },
  text: {
    color: theme.palette.text.secondary,
  },
});

const FarsPagination = ({ classes: c, limit, offset, total, onClick, center, ...props }) =>
  <Pagination
    classes={center ? {root: c.center, textPrimary: c.text} : {textPrimary: c.text}}
    limit={limit}
    offset={offset}
    total={total}
    onClick={onClick}
  />

FarsPagination.defaultProps = {
  center: true,
};

FarsPagination.propTypes = {
  limit: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  center: PropTypes.bool,
}

export const WrappedPagination = withStyles(styles)(FarsPagination)



// WEBPACK FOOTER //
// ./src/components/base/Pagination/Pagination.js